"use strict";

import React from "react";
import Wprr from "wprr";
import moment from "moment";

// import Example from "./Example";
export default class Example extends Wprr.BaseObject {
	
	/**
	 * Constructor
	 */
	_construct() {
		//console.log("Example::constructor");
		
		super._construct();
		
	}
	
	
	_renderMainElement() {
		//console.log("EditPricingPlans::_renderMainElement");
		
		return <div>
			This is just an example
		</div>;
	}
	
	static getWpAdminEditor() {
		console.log("getWpAdminEditor");
		
		let dataSettings = {
			
		};
		
		return React.createElement(Wprr.layout.admin.WpBlockEditor, {dataSettings: dataSettings},
			React.createElement("div", null)
		);
	}
}